import React from "react";
import { format, parseISO } from "date-fns";

const DateComponent = ({ date }) => <div>{date ? format(parseISO(date), 'M/d/Y') : '-'}</div>

export default React.memo(DateComponent);
